"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKnownDomains = void 0;
const validateKnownDomains = ({ domain }) => {
    if (domain.includes('global-selling')) {
        return `https://${domain}/contact-button`;
    }
    return null;
};
exports.validateKnownDomains = validateKnownDomains;
